import React, { Component  } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../CustomButton/CustomButton'

class EditButton extends Component {
  render() {
    return (
      <Button {...this.props} icon wd bsStyle="primary">
        <i className="fa fa-lg fa-pencil"></i>
        <FormattedMessage id='ids_edit'/>
      </Button>
    );
  }
}


export { EditButton };
